import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import MUIDataTable from "mui-datatables";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import LoadingUI from '../../../components/ui/LoadingUI';
import MvmApi from '../../../services/MvmApi';
import utilsDate from '../../../utils/Date';
import { useAuth } from '../../../hooks/auth';

type props =  any;

interface iSummaryData {
    title: string;
    items: iSummaryItem[];
}

interface iSummaryItem {
    title: string;
    mvms: string;
    invoices: string;
}

const MvmMonitorExternalQueue: React.FC<props> = () => {
    const { t: tMvm } = useTranslation("Mvm")
    const { t: tGeneral } = useTranslation("General")
    const {user} = useAuth()

    const { isLoading, isFetching, data } = useQuery('monitorExternalQueue_'+user.company.plantID, async () => {
        return await MvmApi.searchMvmOnConcierge(user.company.plantID);
    } ,{
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60, //calculado em milisegundos - Propriedade para setar qto tempo o cache fica válido
        refetchInterval: 1000 * 60, //calculado em milisegundos - Propriedade para setar qto tempo vai buscar o cache novamente
    });

    const columns = [
        {
            name: 'statusExternalQueue',
            label: '-',
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    style: {
                        width: 200
                    }
                    }),
                setCellProps: (cellValue: string, rowIndex: number, columnIndex: number) => ({
                    align: "center",
                    style: {
                        width: 300,
                        backgroundColor: data![rowIndex].entryStatusFlag != 'WHITE' ? data![rowIndex].entryStatusFlag : '',
                        color: data![rowIndex].entryStatusFlag != 'ORANGE' ? "#ffffff": "", 
                    }
                    
                })
            }
            
        },{
            name: 'driverName',
            label: tMvm("driverName"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: (cellValue: string, rowIndex: number, columnIndex: number) => ({
                    align: "center",
                    style: {
                        backgroundColor: data![rowIndex].entryStatusFlag != 'WHITE' ? data![rowIndex].entryStatusFlag : '',
                        color: data![rowIndex].entryStatusFlag != 'ORANGE' ? "#ffffff": "", 
                    }                   
                })
            }
               
        },{
            name: 'vehiclePlateNumber',
            label: tMvm("vehiclePlateNumber"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center"
                  }),
                setCellProps: (cellValue: string, rowIndex: number, columnIndex: number) => ({
                    align: "center",
                    style: {
                        backgroundColor: data![rowIndex].entryStatusFlag != 'WHITE' ? data![rowIndex].entryStatusFlag : '',
                        color: data![rowIndex].entryStatusFlag != 'ORANGE' ? "#ffffff": "", 
                    } 
                })
            }
        },
        {
            name: 'shippingSupplierCorporateName',
            label: tMvm("shippingSupplier"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: (cellValue: string, rowIndex: number, columnIndex: number) => ({
                    align: "center",
                    style: {
                        backgroundColor: data![rowIndex].entryStatusFlag != 'WHITE' ? data![rowIndex].entryStatusFlag : '',
                        color: data![rowIndex].entryStatusFlag != 'ORANGE' ? "#ffffff": "", 
                    } 
                })
            }
        },  
        {
            name: 'mvmNumber',
            label: tMvm("mvmNumber"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: (cellValue: string, rowIndex: number, columnIndex: number) => ({
                    align: "center",
                    style: {
                        backgroundColor: data![rowIndex].entryStatusFlag != 'WHITE' ? data![rowIndex].entryStatusFlag : '',
                        color: data![rowIndex].entryStatusFlag != 'ORANGE' ? "#ffffff": "", 
                    } 
                })
            }
               
        }, 
        {
            name: 'deliveryWindowDate',
            label: tMvm("deliveryWindowDate"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: (cellValue: string, rowIndex: number, columnIndex: number) => ({
                    align: "center",
                    style: {
                        backgroundColor: data![rowIndex].entryStatusFlag != 'WHITE' ? data![rowIndex].entryStatusFlag : '',
                        color: data![rowIndex].entryStatusFlag != 'ORANGE' ? "#ffffff": "", 
                    } 
                }),
                customBodyRender: (value:any, tableMeta:any, updateValue:any) =>
                {
                    return <span>{utilsDate.DateTime(value)}</span>
                }
            }
        }
    ]

    const options = {
        textLabels: {
            body: {
                noMatch: tGeneral('noMatch'),
                toolTip: "",
            },
            pagination: {
                next: tGeneral("next"),
                previous: tGeneral("previous"),
                rowsPerPage: tGeneral("rowsPerPage") + ":",
                displayRows: tGeneral("of"),
            }
        }
    }

    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: ''                    
                }
            },
            MuiTableRow: {
                root: { '&$selected, &$selected:hover': { backgroundColor: '#d9e6f3', } }
            }
        }
    })

    return (
        <>
        
            <p> {tGeneral("totalRecords")}  {data ? data.length : '0'}</p>

            {isLoading || isFetching ? <LoadingUI /> :
                <MuiThemeProvider theme={myTheme}>
                    <MUIDataTable
                        title=""
                        data={data}
                        columns={columns} 
                        options={{
                            ...options,
                            serverSide: true,
                            pagination: false,
                            sort: false,
                            selectToolbarPlacement: "none",
                            filter: false,
                            search: false,
                            download: false,
                            print: false,
                            viewColumns: false,
                            selectableRows: 'none',                       
                        }}
                    />
                 
                </MuiThemeProvider>
            }
        </>
    )
}
export default MvmMonitorExternalQueue;
